import { DIFFERENTIATORS } from '../data/content';
import { ArrowRight } from 'lucide-react';

interface WhyEpicaSectionProps {
  onOpenDiagnostic: () => void;
}

export default function WhyEpicaSection({ onOpenDiagnostic }: WhyEpicaSectionProps) {
  const accentBorders = [
    'border-l-4 border-blue-500',
    'border-l-4 border-emerald-500',
    'border-l-4 border-rose-500',
    'border-l-4 border-purple-500',
    'border-l-4 border-cyan-500',
    'border-l-4 border-teal-500',
  ];

  const numberColors = [
    'text-blue-600 dark:text-blue-400',
    'text-emerald-600 dark:text-emerald-400',
    'text-rose-600 dark:text-rose-400',
    'text-purple-600 dark:text-purple-400',
    'text-cyan-600 dark:text-cyan-400',
    'text-teal-600 dark:text-teal-400',
  ];

  return (
    <section id="por-que-epica" className="py-20 md:py-28 bg-[#f8f7f4] dark:bg-[#0b131e] text-slate-900 dark:text-white relative transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          {/* Left Column: Heading & Conversemos CTA */}
          <div className="lg:col-span-5 space-y-6 lg:sticky lg:top-32">
            <p className="text-xs font-bold text-rose-700 dark:text-rose-400 tracking-widest uppercase">POR QUÉ ÉPICA</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 dark:text-white tracking-tight leading-tight">
              Lo que nos hace <br className="hidden sm:inline" />
              diferentes
            </h2>
            <p className="text-sm sm:text-base text-slate-600 dark:text-slate-300 leading-relaxed max-w-md">
              No somos una agencia más. Somos un socio estratégico que combina experiencia, creatividad y tecnología para que tu comunicación genere impacto real.
            </p>

            <div className="pt-2 flex items-center gap-4">
              <button
                onClick={onOpenDiagnostic}
                className="flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#123144] hover:bg-[#0c2331] dark:bg-cyan-600 dark:hover:bg-cyan-500 text-white font-bold text-xs tracking-wide shadow-md transition-all active:scale-95"
              >
                <span>Conversemos</span>
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Right Column: 6 Cards (01 to 06) */}
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            {DIFFERENTIATORS.map((item, index) => (
              <div
                key={item.number}
                className={`p-6 bg-white dark:bg-slate-900 rounded-2xl shadow-sm border border-slate-200/80 dark:border-slate-800 ${
                  accentBorders[index % accentBorders.length]
                } space-y-3 hover:shadow-md transition-shadow`}
              >
                <span className={`text-2xl font-black ${numberColors[index % numberColors.length]}`}>
                  {item.number}
                </span>
                <h3 className="text-lg font-black text-slate-900 dark:text-white">{item.title}</h3>
                <p className="text-xs sm:text-sm text-slate-600 dark:text-slate-300 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
